import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { Member_Entity } from "../../entities/member";
import { local420Api } from "../api/local420Api";

const membersAdapter = createEntityAdapter<Member_Entity>();
const initialState = membersAdapter.getInitialState();

export const memberEndpoints = local420Api.injectEndpoints({
  endpoints: (build) => ({
    getMembers: build.query<EntityState<Member_Entity>, void>({
      query: () => `members`,
      transformResponse: (responseData: Member_Entity[]) => {
        return membersAdapter.setAll(initialState, responseData);
      },
      providesTags: ["members"],
    }),
    getMember: build.query({
      query: () => {
        return `members/me`;
      },
      providesTags: (result, error, id) => [{ type: "members", id }],
    }),
    createMember: build.mutation<Member_Entity, Partial<Member_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `members`,
      }),
      invalidatesTags: ["members"],
    }),
    updateMember: build.mutation<
      void,
      { id: number; body: Partial<Member_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `members/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "members", id },
        "members",
      ],
    }),
    deleteMember: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `members/${id}`,
      }),
      invalidatesTags: ["members"],
    }),
  }),
});

export const {
  useGetMemberQuery,
  useLazyGetMemberQuery,
  useGetMembersQuery,
  useCreateMemberMutation,
  useDeleteMemberMutation,
  useUpdateMemberMutation,
} = memberEndpoints;

export default memberEndpoints;
